import { render, staticRenderFns } from "./giftmanage.vue?vue&type=template&id=2c86d146&"
import script from "./giftmanage.vue?vue&type=script&lang=js&"
export * from "./giftmanage.vue?vue&type=script&lang=js&"
import style0 from "./giftmanage.vue?vue&type=style&index=0&id=2c86d146&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports